import { useEffect } from 'preact/hooks';
import { useBlockStore } from '../stores/BlockStore';
import { useFormProps, useConfigStore } from '../stores/ConfigStore';

function getDataField({ block, extra1, extra2 }) {
	if (extra1 === 'extra' && extra2) {
		return block.properties?.elements_extra?.[extra2]?.data_field;
	}
	if (extra1 === 'name' && !block.properties?.elements?.name?.combine) {
		return block.properties?.elements?.name?.subelements?.lastname?.data_field;
	}
	if (extra1 === 'firstname') {
		return block.properties?.elements?.name?.subelements?.firstname?.data_field;
	}

	return block.properties?.elements?.[extra1]?.data_field;
}
export default function useHandleExtraProps(dispatch = () => {}) {
	const { extra } = useFormProps();
	const { actions } = useBlockStore();
	const { layout, blocks, blockRules } = useConfigStore();

	useEffect(() => {
		if (extra?.values) {
			Object.keys(extra.values ?? {}).forEach((field = '') => {
				const [blockId, extra1, extra2] = field
					.replace(/([^1-9]+)/, '') //remove everything before first number
					.split('_');

				if (blockId && !extra1 && !extra2) {
					actions.dispatch({
						type: 'set_value',
						payload: {
							block: blocks[blockId],
							value: extra.values[field],
							rules: blockRules[blockId],
							layout
						}
					});
				} else if (blockId) {
					actions.dispatch({
						type: 'set_nested_value',
						payload: {
							block: blocks[blockId],
							datafieldId: getDataField({
								block: blocks[blockId],
								extra1,
								extra2
							}),
							value: extra.values[field],
							rules: blockRules[blockId],
							layout
						}
					});
				}
			});
		}
	}, [extra, blocks, blockRules, layout]);

	useEffect(() => {
		if (extra?.page) {
			dispatch({
				type: 'to_page',
				payload: extra.page
			});
		}
	}, [extra]);
}
